import { render, staticRenderFns } from "./video-calibration-page.vue?vue&type=template&id=a964a4d8&scoped=true"
import script from "./video-calibration-page.vue?vue&type=script&lang=js"
export * from "./video-calibration-page.vue?vue&type=script&lang=js"
import style0 from "./video-calibration-page.vue?vue&type=style&index=0&id=a964a4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a964a4d8",
  null
  
)

export default component.exports